import { render, staticRenderFns } from "./PopoverFilter.vue?vue&type=template&id=525dd304&"
import script from "./PopoverFilter.vue?vue&type=script&lang=js&"
export * from "./PopoverFilter.vue?vue&type=script&lang=js&"
import style0 from "./PopoverFilter.vue?vue&type=style&index=0&id=525dd304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports